export const ORGANIZATION_STATUSES = {
  supported: 'На сопровождении',
  demo: 'Клиника на тесте',
  training: 'Вузы, колледжи',
  test: 'Разработка',
  archive: 'Архив',
}

export const ORGANIZATION_PARTNERS = {
  dentalpro: 'DentalPro',
}

export const ORGANIZATION_SUBSCRIPTIONS = {
  monthly: 'Месячная',
  yearly: 'Годовая',
  trimonthly: 'Трехмесячная',
}
